import { makeStyles } from '@material-ui/core';
import lexipolLogoWhite from './LexipolLogoWhite.svg';

const useStyles = makeStyles({
  container: {
    width: 28,
    height: 28,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: 28,
    width: 'auto',
    display: 'block',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <span className={classes.container}>
      <img className={classes.logo} src={lexipolLogoWhite} alt="" />
    </span>
  );
};

export default LogoIcon;
